import styled, { css } from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

const StylesTab = css`
    position: relative;
    padding: 6px 24px;
    border-style: solid;
    border-color: transparent;
    background: transparent;
    overflow: hidden;
    font: inherit;
    cursor: pointer;
`;

export const Container = styled.div<{isDisabled : boolean, fontSize?: FONTS}>`
    width: fit-content;
    min-width: max-content;
    max-width: 600px;
    display: flex;
    position: relative;
    box-sizing: content-box;
    ${p => p.fontSize || FONTS.MediumXS};
    background-color: transparent;
    border-radius: 100px;
    border: 2px solid ${COLORS.Outline_Light};
    pointer-events: ${p => p.isDisabled ? 'none' : 'auto' };
    user-select: none;

    @media (max-width: ${wideBreakpoints.mobile}) {
        max-width: 300px;
    }
`;

export const TabLeft = styled.button`
    ${StylesTab};
    border-width: 2px 0 2px 2px;
    border-radius: 100px 0 0 100px;
`;

export const TabRight = styled.button`
    ${StylesTab};
    border-width: 2px 2px 2px 0;
    border-radius: 0 100px 100px 0;
`;

export const LayoutLeft = styled.span<{translateValue: number, colorTab: string}>`
    position: absolute;
    top: 0;
    height: 100%;
    border-radius: 100px;
    transition: transform 100ms ease-in-out;
    width: 100%;
    right: 0;
    background-color: ${p => p.colorTab};
    transform: ${p => `translateX(${p.translateValue}%)`};
`;

export const LayoutRight = styled(LayoutLeft)`
    right: 100%;
`;

export const Text = styled.span<{ isActive: boolean, isDifferentColorText: boolean }>`
    position: relative;
    z-index: 1;
    color: ${(p) => p.isDifferentColorText && !p.isActive ? COLORS.TextPrimary : COLORS.TextWhite};
    white-space: pre;
`;
